import { render, staticRenderFns } from "./TopOffers.vue?vue&type=template&id=70aa2459&scoped=true&"
import script from "./TopOffers.vue?vue&type=script&lang=js&"
export * from "./TopOffers.vue?vue&type=script&lang=js&"
import style0 from "./TopOffers.vue?vue&type=style&index=0&id=70aa2459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aa2459",
  null
  
)

export default component.exports